import { aiValidationApi, AiValidationSummaryParams } from '../api/aiValidationApi';
import type { AiValidationSummary } from '../types/aiValidation';
import { useBaseQuery } from './useBaseQuery';

export const aiValidationKeys = {
    all: ['aiValidation'] as const,
    summary: (params: AiValidationSummaryParams) =>
        [...aiValidationKeys.all, 'summary', params] as const,
};

export const useAiValidationSummary = (params: AiValidationSummaryParams) =>
    useBaseQuery<AiValidationSummary>(
        aiValidationKeys.summary(params),
        () => aiValidationApi.getSummary(params),
        { enabled: !!params.from && !!params.to, staleTime: 60 * 1000 },
    );
